// ref: https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript
// additional ref: https://stackoverflow.com/questions/38781968/problems-downloading-big-filemax-15-mb-on-google-chrome
export default function(dataURI) {
  const binStr = window.atob(dataURI.split(',')[1]),
    len = binStr.length,
    arr = new Uint8Array(len),
    mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]

  for (let i = 0; i < len; i++) {
    arr[i] = binStr.charCodeAt(i)
  }

  return new Blob([arr], {
    type: mimeString
  })
}
